import { asapceoApi } from "../../providers";
import { history } from "../../../_components/_helpers/history";
import { useConnection, utilityAndConfigStore } from "../../store/zustand";
import { config } from "../..";

export const User = (props) => {
  // connection store
  const {
    authToken,
    _hasHydrated,
    authUser,
    users,
    getUsers,
    students,
    setStudents,
    setAuthUser,
    role
  } = useConnection((state) => ({
    users: state.users,
    getUsers: state.getUsers,
    _hasHydrated: state._hasHydrated,
    authUser: state.authUser,
    students: state.students,
    setStudents: state.setStudents,
    setAuthUser: state.setAuthUser,
    role: state.role,
  }));

  // app utility and configuration store
  const { message, setMessage, startLoading, stopALoadingProccess, loading } =
    utilityAndConfigStore((state) => ({
      message:state.message,
      loading: state.loading,
      setMessage: state.setMessage,
      startLoading: state.startLoading,
      stopALoadingProccess: state.stopALoadingProccess,
    }));

  const getAllUsers = () => {
    (async () => {
      const users = await asapceoApi.getAllUsers();

      users.status && getUsers(users.data);
    })();
  };

  const getUser = (userId) => {
    (async () => {
      const user = await asapceoApi.fetchUser(userId);

      user.status && setAuthUser(user.data);
    })();
  };

  const getAllStudents = () => {
    (async () => {
        // start loading a process
        startLoading({
          internalLoading: true,
      })
      const students = await asapceoApi.getStudents();
      students.status && setStudents(students.data);
      students && stopALoadingProccess()
    })();
  };

  const addUser = (data) => {
    (async () => {
      const user = await asapceoApi.addUser(data);
      // report occured error
      user?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: user?.message,
          description: user?.message,
          alert: true,
          inLine: true,
        });

      // report success
      user?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: user?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        });
    })();
  };

  const updateProfile = (data) => {
    (async() => {
      const user = await asapceoApi.updateUser(data)

      // report occured error
      user?.error &&
        setMessage({
          type: "error",
          show: true,
          title: config.constants.authMessage.titleError,
          // description: user?.message,
          description: user?.message,
          alert: true,
          inLine: true,
        });

      // report success
      user?.status &&
        setMessage({
          type: "success",
          show: true,
          title: config.constants.authMessage.titleSuccess,
          // description: user?.message,
          description: config.constants.happyReport,
          alert: true,
          inLine: true,
        });
    })()
  }

  return {
    store: {
      authToken,
      _hasHydrated,
      authUser,
      users,
      loading,
      students,
      role, 
      message
    },
    action: {
      addUser,
      getAllUsers,
      getAllStudents,
      updateProfile,
      getUser
    },
    history,
    ...props,
  };
};
